import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import API from "../api";
import "./EmailPrevareIntroV2.css";
import profile from "../assets/images/profile.png";
import image from "../assets/images/B1-CAWTC-M1-2.png";

const EmailPrevareIntroV2 = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [userData, setUserData] = useState({ first_name: "", last_name: "", username: "", score: 0, rank: 4, completion: "10%", days: 0 });
    const rawUserId = localStorage.getItem("userId");
    const userId = rawUserId && rawUserId !== "null" ? parseInt(rawUserId, 10) : null;
    console.log("Dohvaćeni userId:", userId);

    const [maxSectionsNum, setMaxSectionsNum] = useState();
    const [module_id, setModuleId] = useState(1);
    const [section_id, setSectionId] = useState(1);
    const [screen_id, setScreenId] = useState(1);

    useEffect(() => {
        // Dohvatanje sekcije i ekrana
        API.get(`module/getModuleInfo/${module_id}`).then((response) => {
            setSectionId(response.data[0]?.section_id || 1);
            setScreenId(response.data[0]?.screen_id || 1);
        });

        // Dohvatanje maksimalnog broja sekcija
        API.get(`module/getMaxNumOfSections/${module_id}`).then((response) => {
            setMaxSectionsNum(response.data);
        });
    }, []);

    const onNextPress = () => {
        navigate("/email-next-screen", {
            state: {
                module_id: module_id,
                section_id: section_id,
                screen_id: screen_id,
                screenCounter: 1,
                sectionCounter: 1,
                scorePerQuestion: location.state?.score / maxSectionsNum,
                numberOfTrys: 0,
                score: 0
            }
        });
    };

    useEffect(() => {
        const fetchUserData = async () => {
            const token = localStorage.getItem("token");
            if (!token) {
                console.error("Token nije pronađen, preusmjeravanje na login...");
                navigate("/login");
                return;
            }

            try {
                const response = await API.get("/user/userD"); // Ispravljena ruta
                const data = response.data?.data?.[0];

                if (!data) {
                    console.error("Greška: Nema podataka o korisniku");
                    return;
                }

                setUserData((prevData) => ({
                    ...prevData,
                    first_name: data?.first_name || "N/A",
                    last_name: data?.last_name || "N/A",
                    username: data?.username || "N/A",
                    rank: data?.rank || 4,
                    completion: data?.completion || "10%",
                }));
            } catch (error) {
                console.error("Greška pri dohvaćanju korisničkih podataka:", error);
            }
        };

        fetchUserData();
    }, []);

    useEffect(() => {
        const fetchUserScore = async () => {
            if (!userId) {
                console.error("Greška: userId je null ili nije postavljen.");
                return;
            }
            try {
                const scoreResponse = await API.get(`/module/score/${userId}`);
                const userScore = scoreResponse.data[0]?.score || 0;

                setUserData((prevData) => ({
                    ...prevData,
                    score: userScore,
                }));
            } catch (error) {
                console.error("Greška pri dohvaćanju score-a:", error);
            }
        };

        if (userId) {
            fetchUserScore();
        }
    }, [userId]);

    useEffect(() => {
        const startDate = new Date("2025-12-12"); // Postavi početni datum
        const currentDate = new Date(); // Trenutni datum

        // Izračunaj razliku u danima samo jednom prilikom mountanja komponente
        const timeDifference = startDate - currentDate; // Razlika u milisekundama
        const daysRemaining = Math.floor(timeDifference / (1000 * 3600 * 24)); // Pretvori u dane

        setUserData((prevData) => ({
            ...prevData,
            days: daysRemaining, // Postavi preostale dane
        }));
    }, []); // Ovaj useEffect se pokreće samo pri mountanju komponente


    const handleLogout = () => {
        localStorage.removeItem("token");
        navigate("/login");
    };

    return (
        <div className="dashboard-container">
            <div className="main-content3">
                <div className="content-wrapper">
                    <div className="email-prevare-content3">
                        <h2 className="module-title3">TRAINING MODUL 1 - EMAIL PREVARE</h2>
                        <p className="module-description3">
                            Ovaj Cyber Awareness modul obrađuje phishing napade – jedan od najčešćih načina na koji hakeri ciljaju i kompromituju korisnike.
                        </p>
                        <p className="module-description3">U ovom modulu ćete savladati:</p>
                        <ul className="list">
                            <li>Phishing (klasični i savremeni oblici)</li>
                            <li>Spear phishing (ciljani napadi)</li>
                            <li>Sumnjivi hostname i URL-ovi</li>
                            <li>QR phishing (lažni QR kodovi)</li>
                            <li>AI-generisane phishing poruke</li>
                            <li>Prevenciju i pravilno reagovanje</li>
                        </ul>
                        

                        
                        <button className="next-button3" onClick={onNextPress}>NEXT</button>
                    </div>
                    <div className="media-container3">
                        <img src={image} alt="Media" className="media3" />
                    </div>

                </div>
            </div>

            <div className="sidebar">
                <div className="profile">
                    <img src={profile} alt="Profile" className="profile-img" />
                    <h4>{userData.first_name} {userData.last_name}</h4>
                    <p>@{userData.username}</p>
                </div>

                <div className="profile-info">
                    <div className="profile-info-header">
                        <h4>Profile Info</h4>
                        <p className="see-all">See All</p>
                    </div>
                    <div className="info-item"><span>🏆 Rank:</span> {userData.rank}</div>
                    <div className="info-item"><span>💡 Total score:</span> {userData.score}</div>
                    <div className="info-item"><span>❌ Completion:</span> {userData.completion}</div>
                    <div className="info-item"><span>📅 Days:</span> {userData.days}</div>
                </div>
                <div className="logout-container">
                    <button onClick={handleLogout} className="logout-btn">🚀 Log out</button>
                </div>
            </div>
        </div>
    );
};

export default EmailPrevareIntroV2;